/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_Scene_Descriptions_JobInputs */



/**
* | output |
* | --- |
* | "Automatic Shot Descriptions Job" |
*
* @param {Automatic_Scene_Descriptions_JobInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_scene_descriptions_job = /** @type {((inputs?: Automatic_Scene_Descriptions_JobInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Scene_Descriptions_JobInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Descriptions des prises de vue automatiques")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatische Schussbeschreibungen Job")
	if (locale === "it") return /** @type {LocalizedString} */ ("Lavoro di descrizione automatica delle inquadrature")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Автоматическое описание выстрелов.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Descripción automática de tomas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自动拍摄描述工作")
	if (locale === "ja") return /** @type {LocalizedString} */ ("自動撮影の説明 仕事")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्वचालित शॉट विवरण कार्य")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Descrição automática de tarefas")
	return /** @type {LocalizedString} */ ("Automatic Shot Descriptions Job")
});